/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentSplitDtoV2
 */
export interface PaymentSplitDtoV2 {
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitDtoV2
     */
    amountMinor: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitDtoV2
     */
    locationId: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitDtoV2
     */
    commissionAmountMinor?: number | null;
}

/**
 * Check if a given object implements the PaymentSplitDtoV2 interface.
 */
export function instanceOfPaymentSplitDtoV2(value: object): value is PaymentSplitDtoV2 {
    if (!('amountMinor' in value) || value['amountMinor'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    return true;
}

export function PaymentSplitDtoV2FromJSON(json: any): PaymentSplitDtoV2 {
    return PaymentSplitDtoV2FromJSONTyped(json, false);
}

export function PaymentSplitDtoV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSplitDtoV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'amountMinor': json['amountMinor'],
        'locationId': json['locationId'],
        'commissionAmountMinor': json['commissionAmountMinor'] === undefined ? undefined : json['commissionAmountMinor'] === null ? null : json['commissionAmountMinor'],
    };
}

export function PaymentSplitDtoV2ToJSON(json: any): PaymentSplitDtoV2 {
    return PaymentSplitDtoV2ToJSONTyped(json, false);
}

export function PaymentSplitDtoV2ToJSONTyped(value?: PaymentSplitDtoV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amountMinor': value['amountMinor'],
        'locationId': value['locationId'],
        'commissionAmountMinor': value['commissionAmountMinor'],
    };
}

